import { useCallback } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProviderWorkspace } from "@/features/provider-workspace/provider-workspace";
import {
  workspaceSearchSchema,
  type WorkspaceSearch,
} from "@/features/provider-workspace/workspace-search";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/credentials/",
)({
  validateSearch: workspaceSearchSchema,
  // Links from before the provider page opened a drawer with ?provider=.
  beforeLoad: ({ params, search }) => {
    if (search.provider) {
      throw redirect({
        to: "/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId",
        params: { ...params, affiliationId: search.provider },
        replace: true,
      });
    }
  },
  component: ProviderWorkspaceRoute,
});

function ProviderWorkspaceRoute() {
  const { organizationBusinessUnitId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onNavigate = useCallback(
    (next: WorkspaceSearch) => {
      void navigate({ search: next, replace: true });
    },
    [navigate],
  );
  return (
    <ProviderWorkspace
      key={organizationBusinessUnitId}
      organizationBusinessUnitId={organizationBusinessUnitId}
      search={search}
      onNavigate={onNavigate}
    />
  );
}
